import { offerTypes as actionTypes } from '@actions/v1';
import { commonState, commonReducer } from '@dotone/react-ui-core/helpers';

const defaultState = {
  ...commonState.default(),
};

export const apiOfferCurrent = (state = defaultState, action) =>
  commonReducer(actionTypes.CURRENT, state, action);
